import { t } from "@/i18n-js/instance";
import { EditorCollapsable } from "@circle-react-shared/BuilderUI/Editor/EditorCollapsable";
import { ObjectAlignment } from "../../../../EditorFields/ObjectAlignment";
import { ALIGNMENT_OPTIONS } from "../../../../Themes/Tokens/constants";
import { generateFormItemName } from "./Styles";

export const Alignment = () => (
  <EditorCollapsable
    title={t("builder_ui.prop_type.styles.alignment")}
    defaultOpen
  >
    <div className="px-6 py-4">
      <ObjectAlignment
        name={generateFormItemName("alignment")}
        options={ALIGNMENT_OPTIONS}
      />
    </div>
  </EditorCollapsable>
);
